var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_631_519)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.50043C8.2006 0.403414 5.19377 -0.244655 2.93923 1.67558C0.684679 3.59582 0.36727 6.80634 2.13778 9.07744C3.60984 10.9656 8.0648 14.9481 9.5249 16.2371C9.6882 16.3813 9.7699 16.4534 9.8652 16.4817C9.9483 16.5064 10.0393 16.5064 10.1225 16.4817C10.2178 16.4534 10.2994 16.3813 10.4628 16.2371C11.9229 14.9481 16.3778 10.9656 17.8499 9.07744C19.6204 6.80634 19.3417 3.57562 17.0484 1.67558C14.7551 -0.224455 11.7994 0.403414 10 2.50043Z",
    fill: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.50043C8.2006 0.403414 5.19377 -0.244655 2.93923 1.67558C0.684679 3.59582 0.36727 6.80634 2.13778 9.07744C3.60984 10.9656 8.0648 14.9481 9.5249 16.2371C9.6882 16.3813 9.7699 16.4534 9.8652 16.4817C9.9483 16.5064 10.0393 16.5064 10.1225 16.4817C10.2178 16.4534 10.2994 16.3813 10.4628 16.2371C11.9229 14.9481 16.3778 10.9656 17.8499 9.07744C19.6204 6.80634 19.3417 3.57562 17.0484 1.67558C14.7551 -0.224455 11.7994 0.403414 10 2.50043Z",
    stroke: "#D1D1D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_631_519",
    x: 0.5,
    y: 0.0302734,
    width: 19,
    height: 18.9702,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_631_519"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.a3149d4cb30d1edbb4a07f20dd894b31.svg";
export { ForwardRef as ReactComponent };